<template>
  <div class="skincare-finder-progress">
    <div
      class="skincare-finder-progress--bar"
      :style="progressStyle"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'SkincareFinderProgress',
    data() {
      return {
        currentProgress: 0
      };
    },
    computed: {
      ...mapGetters('quizStore', [
        'progress',
      ]),
      progressStyle() {
        return `width: ${this.currentProgress}%`;
      }
    },
    watch: {
      progress(newProgress) {
        this.currentProgress = newProgress;
      }
    }
  };
</script>

<style src="./SkincareFinderProgress.scss" lang="scss">
